import { paymentMethod } from "@/utils/urlConstants";

export default ({ get }) => ({
  getPaymentMethodList(params) {
    return get(`${paymentMethod.base}`, {
      params: params,
    });
  },
});
